// @ts-nocheck

export default defineNuxtPlugin(async () => {
  const { $gtm } = useNuxtApp()
  const { load: loadNavigation } = useNavigation()
  const config = useRuntimeConfig()
  const userStore = useUserStore()
  const { $localStorage } = useNuxtApp()

  // General i18n chunks
  await useI18n([
    'general',
    'footer',
    'partials',
    'wishlist',
    'cart'
  ])

  // Init navigation
  await loadNavigation()

  // Develop mode gtm
  if (config.public.stage !== 'live') {
    $gtm.push({ develop_mode: true })
  }

  // Get session tokens
  // Push unique userId to gtm
  if (userStore.uniqueId) {
    $gtm.push({ user_id: userStore.uniqueId })
  }

  if (process.server) {
    await $gtm.serverInit()
  } else {
    const preferredShop = await $localStorage.getItem('preferredShop')
    if (preferredShop) {
      userStore.preferredShop = preferredShop
      $localStorage.removeItem('preferredShop')
    }
  }
})
